export var format = function (str, args, autoEscape) {
    if (autoEscape === void 0) { autoEscape = true; }
    if (args != null) {
        return str.replace(/\{([a-zA-Z0-9_]+)\}/g, function (match, key) {
            if (args.hasOwnProperty(key)) {
                var value = args[key];
                if (value != null) {
                    var strValue = value.toString();
                    return autoEscape ? escape(strValue) : strValue;
                }
                else {
                    return '';
                }
            }
            else {
                return match;
            }
        });
    }
    else {
        return str;
    }
};
export var escape = function (text) {
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    return String(text).replace(/[&<>"'`=\/]/g, function (s) {
        return entityMap[s];
    });
};
export var repeat = function (text, count) {
    var result = '';
    for (var i = 0; i < count; i++) {
        result += text;
    }
    return result;
};
